import { J2000 } from "../../AstroConstants.js";
export class VondrakPrecessionAngles {
    static Calculate(tdb) {
        const T = (tdb - J2000) * (1.0 / 36525.0);
        const T2pi = T * (2.0 * Math.PI);
        let Psi_A = 0.0;
        let Omega_A = 0.0;
        let Chi_A = 0.0;
        let Epsilon_A = 0.0;
        let i;
        for (i = 0; i < 18; ++i) {
            let invP = this.precVals[i][0];
            let sin2piT_P, cos2piT_P;
            let phase = T2pi * invP;
            sin2piT_P = Math.sin(phase);
            cos2piT_P = Math.cos(phase);
            Psi_A +=
                this.precVals[i][1] * cos2piT_P +
                    this.precVals[i][4] * sin2piT_P;
            Omega_A +=
                this.precVals[i][2] * cos2piT_P +
                    this.precVals[i][5] * sin2piT_P;
            Chi_A +=
                this.precVals[i][3] * cos2piT_P +
                    this.precVals[i][6] * sin2piT_P;
        }
        for (i = 0; i < 10; ++i) {
            let invP = this.p_epsVals[i][0];
            let sin2piT_P, cos2piT_P;
            let phase = T2pi * invP;
            sin2piT_P = Math.sin(phase);
            cos2piT_P = Math.cos(phase);
            Epsilon_A +=
                this.p_epsVals[i][2] * cos2piT_P +
                    this.p_epsVals[i][4] * sin2piT_P;
        }
        Psi_A +=
            ((289.0e-9 * T - 0.00740913) * T + 5042.7980307) * T + 8473.343527;
        Omega_A +=
            ((151.0e-9 * T + 0.00000146) * T - 0.4436568) * T + 84283.175915;
        Chi_A += ((-61.0e-9 * T + 0.00001472) * T + 0.0790159) * T - 19.65727;
        Epsilon_A +=
            ((-110.0e-9 * T - 0.00004039) * T + 0.3624445) * T + 84028.206305;
        return {
            psi: this.arcSec2Rad * Psi_A,
            omega: this.arcSec2Rad * Omega_A,
            chi: this.arcSec2Rad * Chi_A,
            epsilon: this.arcSec2Rad * Epsilon_A,
        };
    }
    static arcSec2Rad = (Math.PI * 2.0) / (360.0 * 3600.0);
    static precVals = [
        // 1/Pn         psi_A:Cn       om_A:Cn       chi_A:Cn         psi_A:Sn       om_A:Sn       chi_A:Sn
        [
            1.0 / 402.9,
            -22206.325946,
            1267.727824,
            -13765.92405,
            -3243.236469,
            -8571.476251,
            -2206.967126,
        ],
        [
            1.0 / 256.75,
            12236.649447,
            1702.324248,
            13511.858383,
            -3969.723769,
            5309.796459,
            -4186.752711,
        ],
        [
            1.0 / 292.0,
            -1589.008343,
            -2970.553839,
            -1455.229106,
            7099.207893,
            -610.393953,
            6737.949677,
        ],
        [
            1.0 / 537.22,
            2482.103195,
            693.790312,
            1054.394467,
            -1903.696711,
            923.201931,
            -856.922846,
        ],
        [1.0 / 241.45, 150.32292, -14.724451, 0.0, 146.435014, 3.759055, 0.0],
        [
            1.0 / 375.22,
            -13.632066,
            -516.649401,
            -112.300144,
            1300.630106,
            -40.691114,
            957.149088,
        ],
        [
            1.0 / 157.87,
            389.43742,
            -356.794454,
            202.769908,
            1727.498039,
            80.437484,
            1709.440735,
        ],
        [
            1.0 / 274.2,
            2031.433792,
            -129.552058,
            1936.050095,
            299.854055,
            807.300668,
            154.425505,
        ],
        [
            1.0 / 203.0,
            363.748303,
            256.129314,
            0.0,
            -1217.125982,
            83.712326,
            0.0,
        ],
        [
            1.0 / 440.0,
            -896.747562,
            190.266114,
            -655.484214,
            -471.367487,
            -368.654854,
            -243.520976,
        ],
        [
            1.0 / 170.72,
            -926.9957,
            95.103991,
            -891.898637,
            -441.682145,
            -191.881064,
            -406.539008,
        ],
        [1.0 / 713.37, 37.070667, -332.907067, 0.0, -86.169171, -4.26377, 0.0],
        [
            1.0 / 313.0,
            -597.682468,
            131.337633,
            0.0,
            -308.320429,
            -270.353691,
            0.0,
        ],
        [
            1.0 / 128.38,
            66.282812,
            82.731919,
            -333.322021,
            -422.815629,
            11.602861,
            -446.656435,
        ],
        [1.0 / 202.0, 0.0, 0.0, 327.517465, 0.0, 0.0, -1049.071786],
        [1.0 / 315.0, 0.0, 0.0, -494.780332, 0.0, 0.0, -301.504189],
        [1.0 / 136.32, 0.0, 0.0, 585.492621, 0.0, 0.0, 41.34874],
        [1.0 / 490.0, 0.0, 0.0, 110.512834, 0.0, 0.0, 142.525186],
    ];
    static p_epsVals = [
        //  1/Pn         p_A:Cn     eps_A:Cn        p_A:Sn      eps_A:Sn
        [1.0 / 409.9, -6908.287473, 753.87278, -2845.175469, -1704.720302],
        [1.0 / 396.15, -3198.706291, -247.805823, 449.844989, -862.308358],
        [1.0 / 537.22, 1453.674527, 379.471484, -1255.915323, 447.832178],
        [1.0 / 402.9, -857.748557, -53.880558, 886.736783, -889.571909],
        [1.0 / 417.15, 1173.231614, -90.109153, 418.887514, 190.402846],
        [1.0 / 288.92, -156.981465, -353.60019, 997.912441, -56.564991],
        [1.0 / 4043.0, 371.83655, -63.115353, -240.97971, -296.222622],
        [1.0 / 306.0, -216.61904, -28.248187, 76.541307, -75.859952],
        [1.0 / 277.0, 193.691479, 17.703387, -36.788069, 67.473503],
        [1.0 / 203.0, 11.891524, 38.911307, -170.964086, 3.014055],
    ];
}
